import { render, staticRenderFns } from "./AddIncome.vue?vue&type=template&id=55cb8ffd&scoped=true&lang=pug&"
import script from "./AddIncome.vue?vue&type=script&lang=js&"
export * from "./AddIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cb8ffd",
  null
  
)

/* custom blocks */
import block0 from "./AddIncome.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports